import { callHostedTool, listActorWorkspaces } from './actor-service.js'
import { t } from './portal-utils.js'

// VAL-WEB-020: Returns { success: boolean, error?: string }
export async function copyToClipboard(text: unknown): Promise<{ success: boolean, error?: string }> {
  const value = t(text)
  if (!value) return { success: false, error: 'Nothing to copy.' }
  try {
    if (navigator?.clipboard?.writeText) {
      await navigator.clipboard.writeText(value)
      return { success: true }
    }
    const input = document.createElement('textarea')
    input.value = value
    document.body.appendChild(input)
    input.select()
    const result = document.execCommand('copy')
    input.remove()
    return result ? { success: true } : { success: false, error: 'Copy command failed.' }
  } catch (err) {
    return { success: false, error: err instanceof Error ? err.message : String(err) }
  }
}

export async function submitPortalApprovalDecision(workspaceId: string, approvalId: string, status: string) {
  const tool = status === 'approved' ? 'approveAction' : 'rejectAction'
  const firstResult = await callHostedTool(tool, { workspaceId, approvalId })
  return callHostedTool(tool, {
    workspaceId,
    approvalId,
    confirmationId: firstResult.confirmationId,
    confirmToken: firstResult.confirmToken
  })
}

export async function resolveWorkspaceIds(_user: unknown, actor: { actorId?: string } | null): Promise<string[]> {
  return actor?.actorId ? await listActorWorkspaces(actor.actorId) : []
}
